import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: "currentOnly",
    resources: {},
    fallbackLng: "it",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
